<template>
  <div class="editable-page-model-h5-23" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
    <div class="scenetext">
      <div class="scenetext_bt" v-if="editablePageConfig.editable_page_config_content.text[0].list[0]">
        <div class="h3">{{ editablePageConfig.editable_page_config_content.text[0].list[0].content }}</div>
      </div>
      <div class="scenetext_con">
        <div class="scenetext_item" v-for="(item,index) in editablePageConfig.editable_page_config_content.image[0].list" :key="index">
          <img :src="item.path">
          <span>{{ item.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Model23',
  data () {
    return {
    }
  },
  props: ['editablePageConfig']
}
</script>

<style scoped>
.scenetext {
  padding: 0 0.4rem 0.5rem 0.2rem;
  margin-top: 0.6rem;
}
.scenetext_bt .h3 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.25;
  color: #0F1111 !important;
}

.scenetext_con {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  margin-top: 0.6rem;
  overflow-x: scroll;
  overflow-y: hidden;
}
.scenetext_item{
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  white-space: nowrap;
  height: 37.333vw;
  text-align: center;
  position: relative;
  margin-left: 1.333vw;
  object-fit: contain;
  cursor: zoom-in;
}
.scenetext_item img{
  max-width: 32vw;
  height: 37.333vw;
  object-fit: contain;
  border-radius: 1.067vw;
}
.scenetext_item span{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 9.333vw;
  line-height: 12.8vw;
  background: url(https://img.alicdn.com/imgextra/i1/O1CN01Qa2Gm81epPMKCnM34_!!6000000003920-2-tps-200-70.png) no-repeat 0 0;
  background-size: 100% 9.333vw;
  color: #fff;
  font-size: 14px;
}
</style>
